export const DUPLICATE_LINE_ITEM_HEADER = 'Confirm the line item(s) where you want a copy of the ad to be placed.';

export const ERROR_TOOLTIP_TEXT = 'Review ad and select line item(s) to copy it to.';
export const DISABLED_NEXT_TOOLTIP_TEXT = 'Select one or more line items to copy the ad(s) to before proceeding.';
